<div class="form-content">
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submit(form)" #form="ngForm">
    <div class="col-md-7 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between collapse-header">
          <h6 class="text-collapse m-0">{{'Technischer Support'|translate}}</h6>
          <div class="d-flex">
            <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
          </div>
        </div>
        <div class="form-section">
          <div class="form-row">
            <div class="hasValue form-group" [ngClass]="selectedType == 'IT-Ticket' ? 'col-md-4' : 'col-md-6'" [class.has-error]="subject.invalid && (subject.dirty || subject.touched)">
              <label>{{'subject'|translate}} *</label>
              <input type="text" [(ngModel)]="ticket.subject" required class="mnc-control" ngModel name="subject" #subject="ngModel" autofocus="" (change)="checkForSimilarTickets($event)">
            </div>
            <div class="form-group col-md-2 hasValue">
              <label>{{'Priorität'| translate | titlecase }}</label>
              <kendo-dropdownlist name="priority" [data]="priority" ngModel [(ngModel)]="ticket.priority" required></kendo-dropdownlist>
            </div>
            <div class="form-group col-md-2 hasValue">
              <label>{{'Art'| translate | titlecase }}</label>
              <kendo-dropdownlist name="art" [data]="artArray" [textField]="'name'" [valueField]="'id'" valuePrimitive="true" ngModel [(ngModel)]="ticket.art" required></kendo-dropdownlist>
            </div>
            <!-- <div class="form-group col-md-2 hasValue">
              <label>{{'group'| translate | titlecase }}</label>
              <kendo-dropdownlist name="ticketsGroups" [data]="ticketsGroups" ngModel [(ngModel)]="group_id" (valueChange)="selectedGroup()" required [textField]="'name'" [valueField]="'id'"></kendo-dropdownlist>
            </div> -->
            <div *ngIf="selectedType == 'Skynet-Ticket'" class="form-group col-md-2 hasValue">
              <label>{{'category'| translate | titlecase }}</label>
              <kendo-dropdownlist name="ticketsCategory" [data]="categorySkynetTicketData" ngModel [(ngModel)]="ticketCategory" (valueChange)="selectedCategory()" required [textField]="'name'" [valueField]="'name'"></kendo-dropdownlist>
            </div>
            <div *ngIf="selectedType == 'IT-Ticket'" class="form-group col-md-2 hasValue">
              <label>{{'category'| translate | titlecase }}</label>
              <kendo-dropdownlist name="itTicketsCategory" [data]="categoryItTicketData" ngModel [(ngModel)]="itTicketCategory" [textField]="'name'" [valueField]="'name'" (valueChange)="selectedItTicketCategory()" required></kendo-dropdownlist>
            </div>
            <div *ngIf="selectedType == 'IT-Ticket'" class="form-group col-md-2 hasValue">
              <label>{{'subCategory'| translate | titlecase }}</label>
              <kendo-dropdownlist name="itTicketsSubcategory" [data]="itTicketSubcategoryData" ngModel [(ngModel)]="itTicketSubcategory" [textField]="'name'" [valueField]="'name'" (valueChange)="selectedItTicketSubcategory()" required></kendo-dropdownlist>
            </div>
          </div>
          <div style="margin-bottom: 30px; max-height: 380px; overflow-y: scroll; overflow-x: hidden;" *ngIf="similarTickets?.length">
            <label style="margin-bottom: 15px;">{{'Similar Tickets'|translate}}</label>
            <div class="form-row" *ngFor="let item of similarTickets">
              <div class="hasValue form-group col-md-4">
                <label>{{'subject'|translate}} *</label>
                <input type="text" class="mnc-control" name="subject" disabled value="{{item.subject}}">
              </div>
              <div class="form-group col-md-2 hasValue">
                <label>{{'Priorität'| translate | titlecase }}</label>
                <input type="text" class="mnc-control" name="priority" disabled value="{{item.priority}}">
              </div>
              <div class="form-group col-md-2 hasValue">
                <label>{{'Art'| translate | titlecase }}</label>
                <input type="text" class="mnc-control" name="art" disabled value="{{item.art}}">
              </div>
              <div class="form-group col-md-2 hasValue">
                <label>{{'category'| translate | titlecase }}</label>
                <input type="text" class="mnc-control" name="category" disabled value="{{item.ticket_category}}">
              </div>
              <div class="hasValue form-group col-md-1">
                <label>{{'status'|translate}} *</label>
                <input type="text" class="mnc-control" name="status" disabled value="{{item.status}}">
              </div>
              <div class="hasValue form-group col-md-1">
                <button type="button" class="add" (click)="openTicketInNewTab(item.id)" kendoButton primary="true"><i class="fa fa-chevron-circle-right"></i>{{'Go To'|translate}}</button>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="hasValue form-group col-md-12" [class.has-error]="description.invalid && (description.dirty || description.touched)">
              <label>{{'description'|translate}} *</label>
              <kendo-editor [(ngModel)]="ticket.description" #description="ngModel" name="description" required style="min-height: 500px; height: 500px;">
                <kendo-toolbar>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                  <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                  <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                </kendo-toolbar>
              </kendo-editor>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group mt-2 col-md-12 image-upload">
              <h6>{{'place files here to upload them'|translate}}</h6>
              <ngx-dropzone [multiple]="false" (change)="onFilesAdded($event)" style="max-width: 400px; max-height: 60px;">
                <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
              </ngx-dropzone>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6 d-flex flex-wrap filesection-upload">
              <div *ngFor="let f of ticket.files" class="file-row d-flex justify-content-between align-items-center mb-4">
                <div>
                  <a  class="d-block" target="_blank" href="{{ url.ticketFileUrl }}/{{f.fileName}}" download="{{ url.ticketFileUrl }}/{{f.fileName}}">{{ f.originalName}}</a>
                </div>
                <i class="fa fa-times cursor-pointer"  (click)="deleteFile(f)"  aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <div *ngIf="selectedType == 'IT-Ticket'" class="checkbox-group">
              <input type="checkbox" name="intern" kendoCheckBox ngModel [(ngModel)]="ticket.is_private" />
              <label>{{'This ticket is private' | translate}}</label>
            </div>
            <button type="submit" class="btn-save" [disabled]="onSubmit || form.invalid" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>


<div *ngIf="imageEditor.show">
  <app-pspdfkit [saveUrl]="imageEditor.saveUrl" [readUrl]="imageEditor.readUrl" [fileName]="imageEditor.fileName" (closed)="onEditorClosed($event)"></app-pspdfkit>
</div>
